import { render } from "./contactPage.vue?vue&type=template&id=aaa05e84&scoped=true"
import script from "./contactPage.vue?vue&type=script&lang=js"
export * from "./contactPage.vue?vue&type=script&lang=js"

import "./contactPage.vue?vue&type=style&index=0&id=aaa05e84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaa05e84"]])

export default __exports__